import { ReactElement, memo } from 'react';
import { Typography } from 'antd';
import { StyledRow, Cell } from './styles';

const { Text } = Typography;

interface Props {
  id: number;
  rpmApplicantId: string;
  phone: string;
  fullName: string;
  fullNameKana: string;
  applicantStatus: string;
  callResultStatus: string;
  formattedDate: string;
}

const Row = memo(function Row({
  id,
  rpmApplicantId,
  phone,
  fullName,
  fullNameKana,
  applicantStatus,
  callResultStatus,
  formattedDate,
}: Props): ReactElement {
  return (
    <StyledRow>
      <Cell>
        <Text>{id}</Text>
      </Cell>
      <Cell>
        <Text>{rpmApplicantId}</Text>
      </Cell>
      <Cell>
        <Text>{phone}</Text>
      </Cell>
      <Cell>
        <Text>{fullName}</Text>
      </Cell>
      <Cell>
        <Text>{fullNameKana}</Text>
      </Cell>
      <Cell>
        <Text>{applicantStatus}</Text>
      </Cell>
      <Cell>
        <Text>{callResultStatus}</Text>
      </Cell>
      <Cell>
        <Text type='secondary'>{formattedDate}</Text>
      </Cell>
    </StyledRow>
  );
});

export default Row;
